import FilterIcon from './FilterIcon';
import FilterOptionList from './FilterOptionList';
import { FilterColumnProps } from '../types';

const FilterColumn = ({ icon, ...listProps }: FilterColumnProps) => (
    <div className='flex flex-col flex-1 basis-0 min-w-0 border-l border-brand-green-7'>
        <div className='flex items-center gap-2 text-brand-green-30 bg-brand-green-1 text-tmedium uppercase p-4'>
            <FilterIcon icon={icon} size={24} imgSize={20} />
            {/* En una línea: si no entra se corta con "…" y el texto completo queda en el tooltip */}
            <span className='truncate min-w-0' title={listProps.title}>{listProps.title}</span>
        </div>
        <FilterOptionList {...listProps} className='h-[23.56rem]' />
    </div>
);

export default FilterColumn;
